import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Modal/Modal.Footer.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var Footer = _a => {
  var _b = _a,
    {
      className,
      children
    } = _b,
    rest = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */jsx("footer", __spreadProps(__spreadValues({
    className: clsx("pd:modal__footer", className)
  }, rest), {
    children
  }));
};
var Modal_Footer_default = Footer;
export { Modal_Footer_default };